export default {
  CONFIGURATION_BANKACCOUNT_QUERY: {// 完成
    key: 'configuration_bankaccount_query',
    label: '配置管理-银行账号信息维护-【查询】'
  },
  CONFIGURATION_BANKACCOUNT_RESET: {// 完成
    key: 'configuration_bankaccount_reset',
    label: '配置管理-银行账号信息维护-【重置】'
  },
  CONFIGURATION_BANKACCOUNT_SAVE: {// 完成
    key: 'configuration_bankaccount_save',
    label: '配置管理-银行账号信息维护-【保存】'
  },
  CONFIGURATION_BANKACCOUNT_EDIT: {// 完成
    key: 'configuration_bankaccount_edit',
    label: '配置管理-银行账号信息维护-【编辑】'
  },
  CONFIGURATION_BANKACCOUNT_READ: {// 完成
    key: 'configuration_bankaccount_read',
    label: '配置管理-银行账号信息维护-【查看】'
  }
}
